import React from 'react';
import { Counter } from '@hpstellar/core';

import SearchClearFilter from '../../search-filter/components/search-clear-filter';
import SearchFilterCrumbs from '../../search-filter/components/search-filter-crumbs';

class VWAFilterCount extends React.PureComponent {
    static defaultProps = {
        watchFields: /facets.*|price|rating/,
    };

    render() {
        const { watchFields } = this.props;
        return (
            <div className="filter-count-bar">
                <SearchFilterCrumbs>
                    {({ disableSearch, filterCount }) => {
                        {
                            if (disableSearch) {
                                return null;
                            }
                            return (
                                <>
                                    {filterCount > 0 && (
                                        <>
                                            <Counter
                                                className="counter"
                                                count={filterCount}
                                                size="small"
                                                subsetDelimiter="of"
                                            >
                                                FILTER{filterCount > 1 ? 'S' : ''} APPLIED
                                            </Counter>
                                            <SearchClearFilter autoHide={true} watchFields={watchFields} isV2={true} />
                                        </>
                                    )}
                                </>
                            );
                        }
                    }}
                </SearchFilterCrumbs>
            </div>
        );
    }
}

export default VWAFilterCount;
